var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7031 17.2969C14.6406 18.3125 16.2812 18.3125 17.2188 17.2969L29.7188 4.79688C30.7344 3.85938 30.7344 2.21875 29.7188 1.28125C28.7812 0.265625 27.1406 0.265625 26.2031 1.28125L15.5 11.9844L4.71875 1.28125C3.78125 0.265625 2.14062 0.265625 1.20312 1.28125C0.1875 2.21875 0.1875 3.85938 1.20312 4.79688L13.7031 17.2969Z",
    fill: "#34C94B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.352730e2271b88950af8a6bdeac517e6.svg";
export { ForwardRef as ReactComponent };